// Path: ./src/utils/getStoreByMerchant.ts
import { adminApiService } from "./api";

/**
 * this logic should move to backend
 * @deprecated
 * @param merchantId
 * @returns
 */
export const getStoreByMerchantId = async (merchantId: string) => {
  const stores = await adminApiService.getManyBaseGfStoreAdminControllerGfStore(
    undefined,
    `{"merchant.id": "${merchantId}"}`
  );
  return stores.data;
};
